import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { AllowedTimes } from 'src/features/membershipType/types';
import DeleteAllowedTime from 'src/features/membershipType/components/forms/allowedTime/DeleteAllowedTime';
import UpdateAllowedTimeFormModal from 'src/features/membershipType/components/forms/allowedTime/UpdateAllowedTimeFormModal';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface CellAllowedTimeActionsProps extends CellContext<AllowedTimes, unknown> {
    allowedTimesData?: AllowedTimes[];
}
export default function CellAllowedTimeActions({
    row,
    allowedTimesData,
}: CellAllowedTimeActionsProps) {
    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateAllowedTimeFormModal
                        selectedAllowedTime={row.original}
                        allowedTimesData={allowedTimesData}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateAllowedTimeFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>

                <Tooltip>
                    <DeleteAllowedTime
                        selectedAllowedTime={row.original}
                        allowedTimesData={allowedTimesData}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteAllowedTime>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
